import { render, staticRenderFns } from "./PremiumOffers.vue?vue&type=template&id=1baa4bfe&"
import script from "./PremiumOffers.vue?vue&type=script&lang=js&"
export * from "./PremiumOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports